var _rect, _rect2, _defs, _rect3, _defs2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParcelMachine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 247.9 191",
    style: {
      enableBackground: "new 0 0 247.9 191"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.2,
    y: 149.2,
    className: "st0",
    fill: "#383D3D",
    width: 247.7,
    height: 41.8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.2,
    className: "st1",
    fill: "#FEC82A",
    width: 247.7,
    height: 149.2
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 248.3,
    height: 191
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000170236994351786981690000009844974327648200616_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000170236994351786981690000009844974327648200616_)",
      fill: "#35383D"
    },
    d: "M129.5,94.2h-5.6V78 c0-3.4-1.5-5.3-4.3-5.5c-2.1,0-4.3,0.2-6.4,0.7v21h-5.6v-25c4.3-0.9,8.7-1.4,13.1-1.5c2.4-0.1,4.7,0.9,6.4,2.6 c1.7,1.8,2.6,4.2,2.4,6.7L129.5,94.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000170236994351786981690000009844974327648200616_)",
      fill: "#35383D"
    },
    d: "M224.7,94.3 c-0.9,0.3-1.9,0.4-2.9,0.4c-2.3,0.3-4.7-0.5-6.4-2.1c-1-2-1.4-4.2-1.2-6.4v-26h5.6v7.4h4.9v4.6h-4.9v13.8c-0.1,1,0.1,2,0.5,2.9 c0.8,0.7,1.8,1.1,2.9,0.9h1.4V94.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000170236994351786981690000009844974327648200616_)",
      fill: "#FFFFFF"
    },
    d: "M50.3,77.3 c-4.7,1.7-9.7,2.5-14.7,2.6c-5,0-10-0.9-14.8-2.6c4.7-1.7,9.7-2.5,14.8-2.5C40.6,74.7,45.6,75.6,50.3,77.3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000170236994351786981690000009844974327648200616_)",
      fill: "#FFFFFF"
    },
    d: "M70.7,39.7 c-4-2.9-7.6-6.5-10.4-10.6c-2.8-4.1-4.9-8.6-6.2-13.4c4.1,2.9,7.6,6.5,10.5,10.6C67.4,30.4,69.4,34.9,70.7,39.7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000170236994351786981690000009844974327648200616_)",
      fill: "#FFFFFF"
    },
    d: "M55.8,55.9 c-5-0.7-9.9-2.2-14.4-4.6c-4.4-2.3-8.3-5.4-11.7-9c5,0.7,9.8,2.2,14.3,4.5C48.4,49.2,52.4,52.3,55.8,55.9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000170236994351786981690000009844974327648200616_)",
      fill: "#FFFFFF"
    },
    d: "M70,89.6 c3.3-0.4,6.5-1.5,9.2-3.3c0,0-11.7-3.5-11-14.1c2.5-17.4,16.3-30.9,33.7-32.9c-1.9-0.3-3.8-0.4-5.7-0.4 c-21.4-0.2-38.9,17.1-39.1,38.5c0,0,0,0,0,0.1c0.3,21.4,17.9,38.5,39.3,38.2c1.8,0,3.6-0.1,5.3-0.4c-15-1.8-27.6-12.2-32.2-26.5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000170236994351786981690000009844974327648200616_)",
      fill: "#FFFFFF"
    },
    d: "M70.7,114.6 c-4,2.9-7.6,6.5-10.4,10.6c-2.8,4.1-4.9,8.7-6.2,13.5c4-2.9,7.6-6.5,10.4-10.6C67.3,124,69.4,119.4,70.7,114.6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000170236994351786981690000009844974327648200616_)",
      fill: "#FFFFFF"
    },
    d: "M55.8,98.5 c-10,1.3-19.2,6.1-26.1,13.6c5-0.7,9.8-2.2,14.3-4.5C48.4,105.2,52.4,102.1,55.8,98.5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 96.3,
    y: 60.3,
    className: "st4",
    fill: "#35383D",
    width: 5.8,
    height: 33.9
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000093892071277630429780000001081109437932025476_",
    width: 248.3,
    height: 191
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000023248718153724690170000010805065198081344946_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000093892071277630429780000001081109437932025476_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000023248718153724690170000010805065198081344946_)",
      fill: "#35383D"
    },
    d: "M153.9,71.9 c0.5-2.9-1.5-5.7-4.5-6.2c-0.5-0.1-1-0.1-1.5,0h-7.1V78h7c1.7,0.1,3.3-0.5,4.5-1.6C153.5,75.2,154,73.6,153.9,71.9 M159.8,71.8 c0.1,3.1-1,6.1-3.2,8.4c-2.4,2.2-5.5,3.3-8.8,3.2h-7v10.7h-5.8v-34h12.3c3.4-0.2,6.7,0.9,9.2,3.2C158.8,65.6,160,68.7,159.8,71.8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000023248718153724690170000010805065198081344946_)",
      fill: "#35383D"
    },
    d: "M180.6,80.7 c0.1-2.2-0.5-4.3-1.8-6.1c-2-2.6-5.9-3.1-8.5-1.1c-0.4,0.3-0.8,0.7-1.1,1.1c-1.3,1.8-1.9,3.9-1.8,6c-0.1,2.2,0.5,4.3,1.8,6.1 c1.1,1.5,2.9,2.3,4.7,2.2c1.8,0.1,3.6-0.8,4.7-2.2C180,85,180.6,82.9,180.6,80.7 M186.4,80.7c0.2,3.6-1.1,7.1-3.4,9.9 c-4.8,4.9-12.7,5-17.6,0.1c0-0.1-0.1-0.1-0.1-0.1c-2.4-2.7-3.6-6.3-3.4-9.9c-0.2-3.6,1.1-7.1,3.4-9.8c4.9-4.9,12.8-5,17.7-0.1 c0,0,0.1,0.1,0.1,0.1C185.4,73.6,186.6,77.1,186.4,80.7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000023248718153724690170000010805065198081344946_)",
      fill: "#35383D"
    },
    d: "M210.9,85.4 c0.1,2.5-1.1,4.8-3,6.4c-2.3,1.7-5.1,2.6-7.9,2.5c-4.4,0.3-8.7-1.4-11.8-4.6l4.3-3.8c2,2,4.7,3.2,7.5,3.2c1.3,0.1,2.6-0.3,3.8-1 c0.8-0.5,1.4-1.4,1.4-2.3c0.1-1-0.6-1.9-1.6-2.2c-1.6-0.4-3.3-0.7-4.9-0.9c-2.4-0.2-4.8-0.9-6.9-2.1c-1.6-1.2-2.5-3.1-2.4-5.2 c0-2.3,1.1-4.5,3-5.9c2.3-1.7,5-2.5,7.8-2.4c3.7-0.1,7.3,1.3,10.1,3.9l-3.2,3.5C205,73,202.6,72,200,72c-3.2,0-4.9,0.9-4.9,2.8 c0,1.1,0.7,1.8,2.3,2.2l6.4,1.1c4.9,0.9,7.4,3.4,7.4,7.4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000023248718153724690170000010805065198081344946_)",
      fill: "#FFFFFF"
    },
    d: "M217.5,161.6v6h3.2 v-3.1h7.2l-6.9,15.4h3.6l7.1-16v-2.3H217.5z M206,182.5h2.9l8.6-24.6h-2.9L206,182.5z M205.9,172.9h-3.2v-3.7h-3.2v3.7h-6l8.5-11.3 h-3.6l-9,11.8v2.3h10v4.2h3.3v-4.2h3.2V172.9z M179.4,177l4.9-4.6c1.2-1.1,2-2.1,2.4-3c0.4-0.9,0.6-1.8,0.6-2.8 c0-1.6-0.6-2.9-1.8-3.8c-1.2-0.9-2.8-1.4-4.8-1.4c-1.5,0-2.8,0.3-4.1,0.8c-1.2,0.5-2.2,1.3-2.9,2.2l2.4,1.8c1-1.3,2.4-1.9,4.3-1.9 c1.1,0,2,0.2,2.5,0.7c0.6,0.5,0.9,1.1,0.9,2c0,0.6-0.1,1.2-0.4,1.7c-0.3,0.6-0.8,1.3-1.7,2l-7.3,6.9v2.3H188V177H179.4z  M167.9,176.8c-0.5,0.4-1.1,0.6-1.8,0.6c-0.6,0-1.1-0.2-1.4-0.5c-0.3-0.4-0.5-0.9-0.5-1.6v-6.6h3.7V166h-3.7v-3.2h-3.3v3.2h-2.3 v2.6h2.3v6.7c0,1.5,0.4,2.7,1.3,3.5c0.8,0.8,2,1.2,3.5,1.2c0.6,0,1.2-0.1,1.7-0.2c0.5-0.2,1-0.4,1.4-0.7L167.9,176.8z M149.4,177.7 c-0.8,0-1.5-0.2-2-0.5c-0.5-0.3-0.7-0.8-0.7-1.4c0-1.2,0.9-1.9,2.8-1.9h3.4v1.6c-0.3,0.7-0.7,1.2-1.3,1.6 C151,177.5,150.3,177.7,149.4,177.7 M149.9,165.8c-1.1,0-2.2,0.1-3.3,0.4c-1,0.3-1.9,0.7-2.6,1.3l1.3,2.4c0.5-0.4,1.2-0.8,1.9-1 c0.8-0.2,1.5-0.4,2.3-0.4c1.1,0,2,0.3,2.6,0.8c0.6,0.5,0.9,1.3,0.9,2.2v0.2h-3.6c-2,0-3.5,0.4-4.4,1.1c-0.9,0.8-1.4,1.8-1.4,3 c0,0.8,0.2,1.5,0.6,2.2s1,1.1,1.8,1.5c0.8,0.4,1.7,0.5,2.7,0.5c1,0,1.9-0.2,2.7-0.5c0.7-0.3,1.3-0.8,1.7-1.4v1.7h3.1v-8.2 c0-2-0.5-3.5-1.6-4.5C153.5,166.3,151.9,165.8,149.9,165.8 M134.7,165.8c-1.1,0-2.1,0.2-3,0.6c-0.9,0.4-1.6,1-2.2,1.7 c-0.5-0.8-1.1-1.3-1.9-1.7c-0.8-0.4-1.7-0.6-2.8-0.6c-1,0-1.8,0.2-2.6,0.5c-0.8,0.3-1.4,0.8-2,1.4v-1.8h-3.1v13.9h3.3v-7.1 c0-1.4,0.3-2.4,1-3.1c0.7-0.7,1.5-1.1,2.6-1.1c1,0,1.8,0.3,2.3,0.9c0.5,0.6,0.8,1.5,0.8,2.8v7.6h3.3v-7.1c0-1.3,0.3-2.4,1-3.1 c0.7-0.7,1.5-1.1,2.6-1.1c1,0,1.8,0.3,2.3,0.9c0.5,0.6,0.8,1.5,0.8,2.8v7.6h3.3v-8c0-2-0.5-3.6-1.5-4.6 C137.8,166.3,136.4,165.8,134.7,165.8 M106.5,177.3c-1.2,0-2.2-0.4-3-1.2c-0.8-0.8-1.2-1.9-1.2-3.2c0-1.3,0.4-2.4,1.2-3.2 c0.8-0.8,1.8-1.2,3-1.2c1.2,0,2.2,0.4,3,1.2c0.8,0.8,1.2,1.9,1.2,3.2c0,1.3-0.4,2.4-1.2,3.2C108.7,176.9,107.7,177.3,106.5,177.3  M106.5,180.1c1.4,0,2.7-0.3,3.8-0.9c1.1-0.6,2-1.5,2.7-2.5c0.6-1.1,1-2.3,1-3.7s-0.3-2.6-1-3.7c-0.6-1.1-1.5-1.9-2.7-2.5 c-1.1-0.6-2.4-0.9-3.8-0.9c-1.4,0-2.7,0.3-3.8,0.9c-1.1,0.6-2,1.5-2.6,2.5c-0.6,1.1-1,2.3-1,3.7s0.3,2.6,1,3.7 c0.6,1.1,1.5,1.9,2.6,2.5C103.8,179.8,105.1,180.1,106.5,180.1 M94.7,179.9h4l-6.4-8.1l5.8-5.9h-3.9l-6.8,6.3v-11.7h-3.3v19.4h3.3 v-3.7l2.4-2.3L94.7,179.9z M73.3,177.3L81,168v-2.1H69.3v2.6h7.5l-7.6,9.3v2.1h12v-2.6H73.3z M61.7,180.1c1.4,0,2.6-0.3,3.6-0.8 c1-0.6,1.8-1.4,2.4-2.4l-2.5-1.5c-0.4,0.6-0.9,1.1-1.5,1.4c-0.6,0.3-1.3,0.5-2,0.5c-1.2,0-2.2-0.4-3-1.2c-0.8-0.8-1.2-1.8-1.2-3.2 c0-1.3,0.4-2.4,1.2-3.2c0.8-0.8,1.8-1.2,3-1.2c0.7,0,1.4,0.2,2,0.5c0.6,0.3,1.1,0.8,1.5,1.5l2.5-1.5c-0.5-1-1.3-1.8-2.3-2.4 c-1-0.6-2.2-0.8-3.6-0.8c-1.5,0-2.8,0.3-3.9,0.9c-1.1,0.6-2,1.5-2.7,2.5c-0.6,1.1-1,2.3-1,3.7s0.3,2.6,1,3.7 c0.6,1.1,1.5,1.9,2.7,2.5C58.9,179.8,60.2,180.1,61.7,180.1 M44.2,177.7c-0.8,0-1.5-0.2-2-0.5c-0.5-0.3-0.7-0.8-0.7-1.4 c0-1.2,0.9-1.9,2.8-1.9h3.4v1.6c-0.3,0.7-0.7,1.2-1.3,1.6C45.7,177.5,45,177.7,44.2,177.7 M44.6,165.8c-1.1,0-2.2,0.1-3.3,0.4 c-1,0.3-1.9,0.7-2.6,1.3l1.3,2.4c0.5-0.4,1.2-0.8,1.9-1c0.8-0.2,1.5-0.4,2.3-0.4c1.1,0,2,0.3,2.6,0.8c0.6,0.5,0.9,1.3,0.9,2.2v0.2 h-3.6c-2,0-3.5,0.4-4.4,1.1c-0.9,0.8-1.4,1.8-1.4,3c0,0.8,0.2,1.5,0.6,2.2c0.4,0.6,1,1.1,1.8,1.5c0.8,0.4,1.7,0.5,2.7,0.5 s1.9-0.2,2.7-0.5c0.7-0.3,1.3-0.8,1.7-1.4v1.7H51v-8.2c0-2-0.5-3.5-1.6-4.5C48.2,166.3,46.7,165.8,44.6,165.8 M28.4,171.7h-4v-7.3 h4c1.5,0,2.6,0.3,3.4,0.9c0.8,0.6,1.1,1.5,1.1,2.7c0,1.2-0.4,2.1-1.1,2.7C31,171.4,29.9,171.7,28.4,171.7 M28.6,161.6H21v18.3h3.4 v-5.3h4.1c1.6,0,3-0.3,4.1-0.8c1.2-0.5,2.1-1.3,2.7-2.3c0.6-1,0.9-2.1,0.9-3.5c0-1.3-0.3-2.5-0.9-3.5c-0.6-1-1.5-1.7-2.7-2.2 C31.5,161.9,30.1,161.6,28.6,161.6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParcelMachine);
export default __webpack_public_path__ + "static/media/parcelMachine.0ff0cc87aa5c695cb675d9bf8a001f13.svg";
export { ForwardRef as ReactComponent };